<template>
  <div class="animated fadeIn">
    <span v-show="false">{{ reactivity }}</span>
    <!-- loading component -->
    <!-- <Loading /> -->
    <div class="mb-2">
      <BannerSlider :images="banners" :clickable="false" />
    </div>
    <b-card style="border: 0">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <h3 class="text-danger">اطلاعیه مهم</h3>
        <h5 class="text-danger">
          با توجه به بازطراحی فرآیند اجرای طرح و تغییر رویکرد در ثبت و بررسی
          طرح‌ها، موضوعات فناوری هر دانشگاه به‌صورت مستقل و در قالب فراخوان
          اختصاصی دانشگاه اعلام و پیگیری خواهد شد.
        </h5>
        <h5 class="text-danger">
          بر این اساس، ثبت طرح در سامانه صرفاً در بازه زمانی تعیین‌شده برای
          فراخوان دانشگاه مربوطه امکان‌پذیر خواهد بود.
        </h5>
        <h5 class="text-danger">
          اطلاعات مربوط به زمان‌بندی و نحوه ثبت طرح‌ها متعاقباً از طریق کانال
          اطلاع‌رسانی طرح تقسیم کار ملی در پیام‌رسان بله اعلام خواهد شد.
        </h5>
        <h5 class="text-danger">
          جهت دریافت اطلاعات بیشتر، می‌توانید با دبیرخانه طرح تقسیم کار ملی تماس
          حاصل فرمایید.
        </h5>
      </div>
    </b-card>
    <b-card style="border: 0">
      <b-row>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-col>
            <b-form-group label="عنوان کلان پروژه">
              <h4 class="text-primary">
                {{ banner.uniRequestTitle }}
              </h4>
            </b-form-group>
          </b-col>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-col>
            <b-form-group label="عنوان پروژه">
              <h4 class="text-primary">
                {{ banner.title }}
              </h4>
            </b-form-group>
          </b-col>
        </div>
      </b-row>
      <b-row>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <b-col>
            <b-form-group label="آپلود فایل ورد پروپوزال*">
              <!-- :disabled="Boolean(Object.keys(proposalFileData).length)" -->
              <b-form-file
                :state="Boolean(Object.keys(proposalFileData).length)"
                :disabled="true"
                @input="uploadProposal(proposalFile)"
                v-model="proposalFile"
                browse-text="بارگذاری"
                :placeholder="
                  Object.keys(proposalFileData).length
                    ? proposalFileData.name
                    : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                "
              ></b-form-file>
              <b-col>
                <b-row
                  align-h="end"
                  v-if="Object.keys(proposalFileData).length"
                >
                  <span class="mt-3 ml-2" style="float: left"
                    ><a
                      class="btn btn-success white--text"
                      :href="proposalFileData.url"
                      target="_blank"
                      >دریافت</a
                    ></span
                  >
                  <b-button
                    style="height: 35px; float: left"
                    class="btn ml-2 mt-3"
                    variant="danger"
                    @click="
                      proposalFileId = null;
                      proposalFile = {};
                      proposalFileData = {};
                    "
                    >حذف</b-button
                  >
                </b-row>
              </b-col>
            </b-form-group>

            <b-button
              id="downLoad"
              variant="link"
              href="https://api.biodcportal.com/setad/public/پروپوزال%20خرده%20پروژه%20ها.doc"
            >
              <b-tooltip
                placement="bottomleft"
                target="downLoad"
                triggers="hover"
                variant="info"
                >دانلود نمونه فایل</b-tooltip
              >
              نمونه فایل پروپوزال
            </b-button>
          </b-col>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <b-col>
            <v-btn
              @click="submit()"
              :loading="loading"
              :disabled="true"
              class="mt-5 green-btn"
              variant="success"
            >
              ثبت درخواست
            </v-btn>
            <!-- :disabled="busy || !proposalFileId" -->
          </b-col>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import BannerSlider from "./BannerSlider.vue";
export default {
  components: { BannerSlider },
  name: "newUniRequestForm",
  data() {
    return {
      proposalFileId: null,
      proposalFile: {},
      busy: false,
      myFilepro: new Object({
        uploadPercentage: 0,
      }),
      showProgress: false,
      striped: true,
      reactivity: false,
      isUploaded: false,
      max: 100,
      loading: false,
      banner: {},
      bannerId: "",
      banners: [],
      proposalFileData: {},
    };
  },
  methods: {
    submit() {
      return;
      this.busy = true;
      this.loading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/unirequest/" + this.bannerId,
          {
            proposalFileId: this.proposalFileId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.clearForm();
            this.$set(this, "proposalFileId", null);
            this.busy = false;
            this.loading = false;
            this.$router.push("/researcher/dashboard");
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");

          this.busy = false;
          this.loading = false;
        });
    },
    clearForm() {
      this.proposalFileId = null;
      this.$refs.proposalFile.reset();
    },
    uploadProposal(file, index) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.proposalFileData.showProgress = true;
        this.proposalFileData.variant = "info";
        this.proposalFileData.uploadPercentage = 0;
        this.proposalFileData.isUploaded = false;
        this.proposalFileData.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl + "/setad/researcher/unirequest/upload/",
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.proposalFileData.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.proposalFileData.isUploaded = true;
              this.proposalFileData.uploadPercentage = 100;
              this.proposalFileData.striped = false;
              this.proposalFileData.variant = "success";
              this.proposalFileData.uploadButDisable = false;
              this.proposalFileData = d.data;
              this.proposalFileId = this.proposalFileData.id;
              // this.rfps[index].url = this.proposalFileData.url;
              this.$forceUpdate();
              this.toast("فایل با موفقیت بارگذاری کردید.", "success");
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data.error, "error");
            this.contractFile = null;
            this.proposalFileData.uploadPercentage = 0;
            this.proposalFileData.isUploaded = false;
          });
      }
    },
    getBannerInfo() {
      this.$http
        .get(this.baseUrl + "/setad/researcher/banner/" + this.bannerId, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.banner = res.data;
          this.banners = [this.banner];
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    this.bannerId = localStorage.getItem("bannerId");
    this.getBannerInfo();
  },
};
</script>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>

<style lang="scss" scoped>
.btn-light {
  color: #1f618d !important;
  background-color: #eaf2f8 !important;
  transition: 0.3s all ease-in-out;
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 8px !important;
  border: 0;
  box-shadow: 0px 0px 15px #154360;

  &:hover {
    color: #fff !important;
    box-shadow: none;
    transition: 0.3s all ease-in-out;
    background: linear-gradient(200deg, #154360 0%, #5499c7 100%);
  }
}
.btn-yahoo {
  color: #4a235a !important;
  background-color: #d9d0db !important;
  transition: 0.3s all ease-in-out;
  margin-bottom: 15px;
  padding: 15px;
  box-shadow: 0px 0px 15px #4a235a;
  border-radius: 8px !important;
  border: 0;

  &:hover {
    color: #fff !important;
    box-shadow: none;
    transition: 0.3s all ease-in-out;
    background: linear-gradient(200deg, #4a235a 0%, #9954c7 100%);
  }
}
</style>
